import { ENTITY_LISTING_VIEW_TYPE } from '../../../../../constants/common'
import {
  getListViewTypeWithPreview,
  isListViewTypeBoard,
  isListViewTypeWithPreview,
} from '../../../../../utils/listViewType'
import {
  APPLICANT_COMPARE_VIEW_TYPE,
  APPLICANT_PREVIEW_REGIME_AVAILABLE,
  APPLICANT_VIEW_TYPES,
} from '../../RentalPortalApplicants.constants'

import { APPLICANTS_VIEW_PARAM } from './useRentalPortalApplicantsViewRegime.constants'

export function getApplicantsTableViewRegime(listViewType) {
  return APPLICANT_PREVIEW_REGIME_AVAILABLE &&
    isListViewTypeWithPreview(listViewType)
    ? getListViewTypeWithPreview(ENTITY_LISTING_VIEW_TYPE.table)
    : ENTITY_LISTING_VIEW_TYPE.table
}

export function getApplicantsViewRegime({
  hasStage,
  isCompareAvailable,
  searchParams,
}) {
  const view = searchParams.get(APPLICANTS_VIEW_PARAM)

  if (view === APPLICANT_COMPARE_VIEW_TYPE) {
    return isCompareAvailable ? view : getApplicantsTableViewRegime(view)
  }

  return APPLICANT_VIEW_TYPES.includes(view) &&
    (hasStage || !isListViewTypeBoard(view)) &&
    (APPLICANT_PREVIEW_REGIME_AVAILABLE || !isListViewTypeWithPreview(view))
    ? view
    : getApplicantsTableViewRegime(view)
}
